import { useCallback, useEffect, useState } from "react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * What's New Banner — reads CHANGELOG.md via /api/whats-new and shows the
 * most recent 3 changelog headlines so Shannon (and LP guest logins) see
 * every new capability the moment production catches up.
 */
const WhatsNewBanner = () => {
  const [items, setItems] = useState([]);
  const [dismissed, setDismissed] = useState(false);
  const [err, setErr] = useState(false);

  const load = useCallback(async () => {
    try {
      const r = await fetch(`${BACKEND_URL}/api/whats-new?limit=3`, { credentials: "include" });
      if (r.ok) {
        const d = await r.json();
        setItems(d.items || []);
      } else {
        setErr(true);
      }
    } catch { setErr(true); }
  }, []);

  useEffect(() => { load(); }, [load]);

  if (err || dismissed || items.length === 0) return null;

  return (
    <div data-testid="whats-new-banner" style={{
      background: "linear-gradient(90deg, rgba(232,184,196,0.15), rgba(184,145,90,0.12))",
      border: "1px solid rgba(232,184,196,0.4)",
      borderRadius: 8,
      padding: "0.75rem 1rem",
      display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: "0.7rem",
    }}>
      <div style={{ minWidth: 0, flex: 1 }}>
        <div style={{ color: "#E8B8C4", fontSize: "0.68rem", letterSpacing: "0.22em", textTransform: "uppercase", fontWeight: 800 }}>
          🎉 What&apos;s New This Deploy
        </div>
        <ul style={{ margin: "6px 0 0", padding: "0 0 0 1.1rem", color: "#F5EFE1" }}>
          {items.map((it, i) => (
            <li key={i} data-testid={`whats-new-item-${i}`} style={{ fontSize: "0.82rem", marginBottom: 2 }}>
              {it.headline}
            </li>
          ))}
        </ul>
      </div>
      <button type="button" onClick={() => setDismissed(true)} data-testid="whats-new-dismiss"
              style={{ background: "transparent", color: "#E8B8C4", border: "1px solid rgba(232,184,196,0.4)",
                       padding: "0.3rem 0.7rem", borderRadius: 4, fontSize: "0.72rem", fontWeight: 700, cursor: "pointer",
                       whiteSpace: "nowrap", height: "fit-content" }}>
        Dismiss ✕
      </button>
    </div>
  );
};

export default WhatsNewBanner;
